import React,{useEffect} from 'react';
import {Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Paper from '@mui/material/Paper';
import Title from './Title';
import {OnlineCostPer,OnlineBookCostPer} from './Inc';

const Term = ()=> {
    const classes = useStyles();
    
    useEffect( ()=>{
        window.scrollTo(0,0);
    },[]);

    return (
        <div id="term" className={classes.root+" "+classes.policy}>
            <Paper className={classes.paper}>
                <Title text="SideB利用規約" icon="assignment"/>

                <div className="lead">有限会社レトロインク（以下、当社）は、当社が運営するサービス「架空ストアSideB」（以下、本サービス）の利用と提供に関し、以下の通り、SideB利用規約（以下、本規約）を定めます。</div>

                <div className="qaBox">
                <h3>[1] 本サービスの利用</h3>
                <ol>
                <li>本サービスに作家登録および商品登録（以下、登録情報）を行い、登録された商品（以下、商品）の販売を行う方（以下、作家）は、その商品の著作権を有するか、もしくは正当な著作権者から著作権の取り扱いの委任を受けている必要があります。</li>
                <li>作家は、商品を納品する前に、この利用規約および免責事項（以下、本規約）への同意をお願いいたします。また、商品の納品が行われた時点で、本規約に同意したものとさせていただきます。</li>
                </ol>
                </div>

                <div className="qaBox">
                <h3 >[2] 本サービスの試用</h3>
                <ol>
                <li>本サービスは試用が認められています。作家登録、商品登録を行っても、商品の納品を行わない場合は、試用とみなします。</li>
                <li>本サービスの試用においては、本規約への同意は必要ありません。</li>
                </ol>
                </div>

                <div className="qaBox">
                <h3 >[3] 納品</h3>
                <ol>
                <li>電子書籍として登録された商品（以下、電子書籍商品）については、「販売許可申請」を行った時点で、納品とみなします。</li>
                <li>雑貨・アート作品など、電子書籍商品以外の商品（以下、実商品）については、商品委託書が運営者に提出された時点で、納品とします。</li>
                </ol>
                </div>

                <div className="qaBox">
                <h3 >[4] 販売形態</h3>
                <ol>
                <li>運営者は、商品をオンラインショップおよび実店舗にて販売を行います。</li>
                <li>商品の発売日は、作家が決定します。ただし、実店舗の店頭への陳列の有無は、運営者の判断に一任するものとします。</li>
                </ol>
                </div>

                <div className="qaBox">
                <h3 >[5] 利用料金と手数料</h3>
                <ol>
                <li>作家は、運営者が購入者から販売代金を受領した際は、その販売代金に運営者が定める料率を乗じた金額を、本サービスの利用料金として、運営者に支払うものとします。</li>
                <li>利用料金の料率は、原則として販売代金の{OnlineCostPer}％とします。ただし、運営者と作家の間で別途取り決めのある場合は、その限りではありません。</li>
                </ol>
                </div>

                <div className="qaBox">
                <h3 >[6] 支払</h3>
                <ol>
                <li>作家は、支払申請により、運営者に対して販売代金の支払いを求めることができます。</li>
                <li>支払申請を受けた運営者は、申請から48時間以内に、送金予定日を決定し、作家に通知します。</li>
                <li>支払いは、作家の指定する金機関口座への振込で行われます。その際、作家は運営者に送金手数料を支払います。</li>
                </ol>
                </div>

                <div className="qaBox">
                <h3 >[7] 返品</h3>
                <ol>
                <li>作家は、納品した商品のうち購入されていない商品について、販売を中止し、引き取ることができます。</li>
                <li>商品の引き取り手段については、運営者と作家の間で話し合いを行い、両社が適当と判断する方法で行われます。その際に、送料などが必要となる場合には、作家の負担とします。</li>
                </ol>
                </div>

                <div className="qaBox">
                <h3 >[8] 委託継続の意思確認</h3>
                <ol>
				<li>過去２年間にわたり本サービスにおける納品および商品の売上のない作家に対し、取り扱いの一時停止措置（以下、一時停止）を行います。</li>
				<li>一時停止の間は商品の販売および登録内容の修正が行えません。</li>
				<li>作家は本サービス上で一時停止の解除ができます。解除後２年間は再び一時停止になることはありません。</li>
				<li>一時停止のまま６か月が経過した場合、作家に委託継続の意思がないものとして、作家への本サービスの利用を終了とし、商品売上の残高がある場合には作家がその受け取りの放棄に同意したものと見なします。</li>
                </ol>
                </div>

                <div className="qaBox">
                <h3 >[9] 商品の破棄</h3>
                <ol>
                <li>以下の条件のいずれかを満たす場合、本サービスは商品の破棄ができるものとします。<br/>
                （１）一時停止のまま６か月が経過した。<br/>
                （２）商品引取の申し込みから１ヶ月が経過しても、商品の引き渡しが完了しなかった。<br/>
				（３）作家が商品の破棄に同意した。<br/>
                </li>
                <li>作家から本サービスに対して、２年間以上連絡の取れなくなることがあらかじめ予告されていた場合、および、事故や災害などのやむをえない事由で作家から本サービスへの連絡が困難となっていることが明らかになった場合は、本サービスの判断で商品の破棄を延期する場合があります。</li>
                <li>この規約により商品の破棄が行われた場合、本サービスは作家に対して、破棄された商品に関する補償は一切いたしません。</li>
                </ol>
                </div>


                <div className="qaBox">
                <h3 >[10] 取り扱いできない商品</h3>
                <ol>
                <li>以下のような作品は取り扱いできません。<br/>
                <ol type="A">
                <li>極端に大きい、重いなど保管が困難となる商品</li>
                <li>壊れやすいなど、特別な輸送手段が必要な商品</li>
                <li>短い期間で品質が劣化するなど、品質維持に手間のかかる商品</li>
                <li>税込単価が100円未満の商品（複数組み合わせて100円以上のセットにすれば可）</li>
                <li>その他、取り扱いに難があると架空ストアが判断した商品</li>
                </ol>
                </li>
                </ol>
                </div>

                <div className="qaBox">
                <h3 >[11] 商品の著作権等</h3>
                <ol>
                <li>運営者は、商品の著作権についての事前審査はおこないません。登録後に著作権上の問題がある又はその可能性があると判明した場合には、運営者の判断で、販売を停止し、登録情報を削除する場合があります。</li>
                <li>作家が商品を本サービス以外のサイトや媒体で公開および販売することに関しては、運営者は一切関与しません。</li>
                <li>作品登録後に、作家と第三者の間で著作権に関する譲渡や委任などが行われた場合は、商品登録を削除し、必要に応じて再度登録を行うものとします。</li>
                <li>作家は運営者に対して、登録情報を本サービスの円滑な提供、本サービスのシステムの構築、改良、メンテナンスに必要な範囲内で使用することを許諾するものとします。</li>
                <li>運営者は、登録情報を本サービスの円滑な提供、本サービスのシステムの構築、改良、メンテナンス以外の目的に利用することはありません。<br/>
                また、広告宣伝のためなど、正当な事情で登録情報の一部を本サービス以外のサイトや媒体で利用する場合でも、作家に事前に通知し、了解を得るものとします。</li>
                </ol>
                </div>

                <div className="qaBox">
                <h3 >[12] 電子書籍商品の著作権等</h3>
                <ol>
                <li>本サービスで電子書籍商品として扱う作品の著作権は、登録前の作品原稿の著作権に準じます。電子書籍商品は、電子書籍として購入者に提供されるデータ以外に、中間データ（PDFやePubを生成するための基本的なデータ）がサーバー上に保存されますが、これについても同様の著作権を認めるものとします。</li>
                </ol>
                </div>

                <div className="qaBox">
                <h3 >[13] 電子書籍商品の出版権等</h3>
                <ol>
                <li>本サービスで扱う電子書籍商品の発行者は、有限会社レトロインク石村寛之とします。</li>
                <li>発行者が有する出版権は、本サービスの電子書籍ダウンロード販売による出版に限定されます。同じ原稿を使用した商品が他の媒体や店舗で販売される場合、発行者は出版権を主張しません。</li>
                <li>作家は、本サービスの電子書籍作成システムで作成された電子書籍ファイル（PDF、ePubなど）を印刷し、本サービス以外の媒体又は店舗で、販売・配布する権利を有します。ただし、その際に奥付（発行者名などの表記）を改変することは禁止とします。</li>
                <li>発行者は、いかなる理由があろうとも、第三者（作品の著作者以外）に出版権の譲渡や利用の許諾を行うことはありません。</li>
                </ol>
                </div>

                <div className="qaBox">
                <h3 >[14] 登録情報の管理</h3>
                <ol>
                <li>登録情報は、作家が自己の判断と責任により、登録するものとし、その内容によって作家に不利益が生じても運営者は一切責任を負わないものとします。</li>
                <li>作家は運営者に対して、本サービスの利用にあたり第三者の権利を侵害しないことを保証するものとし、第三者との間で何らかの紛争が発生した場合には、運営者を除く両者の費用と責任において問題を解決するものとします。</li>
                </ol>
                </div>

                <div className="qaBox">
                <h3 >[15] 登録情報以外の著作権等</h3>
                <ol>
                <li>本サービスに含まれている作家情報および商品情報以外の情報、商標、画像、広告、デザイン等（以下、コンテンツ）に関する著作権、商標権その他の財産権は、運営者もしくは正当な権利を有する第三者（以下、権利者）に帰属するものとします。</li>
                <li>作家が前項に反する行為によって被った損害については、運営者は一切の責任を負わないものとします。また、作家がこれらの行為によって利益を得た場合、運営者はその利益相当額を請求できるものとします。</li>
                </ol>
                </div>

                <div className="qaBox">
                <h3 >[16] 作家への通知・連絡</h3>
                <ol>
                <li>運営者が作家に対して、通知、連絡等を行う必要があると判断した場合、電子メール、本サービスのWebサイトへの掲載など、当社が適当と判断する方法により行うものとします。</li>
                <li>前項における電子メールによる通知、連絡等は、作家が本サービスに登録している電子メールアドレスに対して行うものとします。</li>
                <li>運営者が通知、連絡等を本サービスのWebサイト上で行う場合は、当該通知、連絡等をWebサイトに掲載した日をもって、作家に当該通知、連絡等が到達したものとみなします。また、電子メールによって通知、連絡等を行う場合には、運営者が作家に対して電子メールを発信した時点をもって、作家に当該通知、連絡等が到達したものとみなします。</li>
                </ol>
                </div>

                <div className="qaBox">
                <h3 >[17] 禁止事項</h3>
                <ol>
                <li>作家は、本サービスの利用に関して、以下の行為を行ってはならないものとします。<br/>
                <ol type="A">
                <li>運営者若しくは第三者の著作権、商標権などの知的財産権その他の権利を侵害する行為、又は侵害するおそれのある行為</li>
                <li>法令若しくは公序良俗に違反し、又は運営者若しくは第三者に不利益を与える行為</li>
                <li>他者を差別若しくは誹謗中傷し、又はその名誉若しくは信用を毀損する行為</li>
                <li>詐欺等の犯罪に結びつく又は結びつくおそれがある行為</li>
                <li>わいせつ、児童ポルノ又は児童虐待にあたる画像、文書等を送信又は掲載する行為</li>
                <li>第三者になりすまして本サービスを利用する行為</li>
                <li>ウィルス等の有害なコンピュータプログラム等を送信又は掲載する行為</li>
                <li>その行為が前各号のいずれかに該当することを知りつつ、その行為を助長する態様・目的でリンクをはる行為</li>
                <li>その他、運営者が不適当と判断する行為</li>
                </ol>
                </li>
                <li>運営者は、本サービスの利用に関して、作家の行為が前項各号のいずれかに該当するものであること、又は作家の提供した情報が前項各号のいずれかの行為に関連する情報であると判断した場合、事前に作家に通知することなく、本サービスの全部又は一部の提供を一時停止し、又は前項各号に該当する行為に関連する情報を削除する等の運営者が必要と認める措置を行うことができるものとします。</li>
                <li>運営者は、作家の行為又は作家が提供又は伝送する情報を監視する義務を負うものではありません。第三者の行為が作家の行為とみなされる場合についても同様です。</li>
                </ol>
                </div>

                <div className="qaBox">
                <h3 >[18] 他サイトへのリンク</h3>
                <ol>
                <li>本サービスからリンクされている外部のサイトおよび本サービスに掲載されている広告からリンクされているサイトは、それぞれの運営者・広告主の責任によって管理されており、運営者は、これらのサイトについて、違法なものでないこと、内容が正確であること、不快な内容を含まないものであること、作家が意図していない情報を含まないものであること等を一切保証いたしません。</li>
                </ol>
                </div>

                <div className="qaBox">
                <h3 >[19] 個人情報</h3>
                <ol>
                <li>運営者が本サービスで取得した作家の個人情報は、当社が別途定める<Link to="/privacy" className="link">プライバシーポリシー</Link>に従って取り扱うものとします。</li>
                </ol>
                </div>

                <div className="qaBox">
                <h3 >[20] 本サービスの変更・終了等</h3>
                <ol>
                <li>運営者は、本サービスの全部又は一部を変更、中断、又は終了する際には、作家へ事前の通知を行うものとします。ただし、緊急を要すると運営者が判断した場合には、事後の通知でそれに代えることができるものとします。また、それにより作家や第三者が損害を被った場合でも運営者は一切の責任を負わないものとします。本サービスにおいて提供する情報の内容についても同様です。</li>
                </ol>
                </div>

                <div className="qaBox">
                <h3 >[21] 本サービスの停止</h3>
                <ol>
                <li>運営者は、以下のいずれかに該当する場合には、作家に事前に通知することなく一時的に本サービスを中断することができるものとします。<br/>
                <ol type="A">
                <li>サーバ、通信回線若しくはその他の設備の故障、障害の発生又はその他の事由により本サービスの提供ができなくなった場合</li>
                <li>システム(サーバ、通信回線や電源、それらを収容する建築物などを含む)の保守、点検、修理、変更を定期的に又は緊急に行う場合</li>
                <li>火災、停電などにより本サービスの提供ができなくなった場合</li>
                <li>地震、噴火、洪水、津波などの天災により本サービスの提供ができなくなった場合</li>
                <li>戦争、変乱、暴動、騒乱、労働争議、疫病の蔓延等その他不可抗力により本サービスの提供ができなくなった場合</li>
                <li>法令による規制、司法命令等が適用された場合</li>
                <li>その他、運用上、技術上当社が本サービスの一時的な中断を必要と判断した場合</li>
                </ol>
                </li>
                </ol>
                </div>

                <div className="qaBox">
                <h3 >[22] 本規約の改定・修正・変更</h3>
                <ol>
                <li>運営者は、本規約の全部又は一部を変更、中断、又は終了する際には、作家へ事前の通知を行うものとします。ただし、緊急を要すると運営者が判断した場合には、事後の通知でそれに代えることができるものとします。改定後に本サービスのご利用があった場合、改定後の規約に同意したものとさせていただきます。</li>
                </ol>
                </div>

                <div className="qaBox">
                <h3 >[23] その他</h3>
                <ol>
                <li>本規約は、日本法に基づき解釈されるものとし、本規約に関して訴訟の必要が生じた場合には、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</li>
                <li>本規約の解釈を巡って疑義が生じた場合、当社は合理的な範囲でその解釈を決定できるものとします。</li>
                </ol>
                </div>

                <div className="qaBox">
                2011年5月8日　施行<br/>
                2012年4月23日　改定<br/>
                2015年10月11日　改定<br/>
                2018年9月9日　改定<br/>
				2022年4月9日　改定（[5] 利用料金と手数料）<br/>
				2023年8月24日　改定（[8] 委託継続の意思確認　[9] 商品の破棄）<br/>
                2026年9月19日　改定（[5] 利用料金と手数料）<br/>
                <br/>
                架空ストア/有限会社レトロインク<br/>
                代表取締役　石村寛之<br/>
                </div>

            </Paper>
        </div>
    )
}

export default Term;